import ConfirmButton from 'src/components/atoms/ConfirmButton/ConfirmButton';

export default ConfirmButton;
